import { type TransformerConfig } from '../common/types';
import { createDecodeFromDbFn, createEncodeToDbFn } from '../common/utils';
import { createTimestampTransformer } from '../common/sql';
import {
  AttemptScanPageSchema,
  AttemptScanSchema,
  DBAttemptScanPageSchema,
  DBAttemptScanSchema,
  DBListedAttemptScanSchema,
  ListedAttemptScanSchema,
} from './schemas';

export const AttemptScanCodecConfig: TransformerConfig<
  typeof AttemptScanSchema,
  typeof DBAttemptScanSchema
> = {
  name: 'AttemptScan',
  clientSchema: AttemptScanSchema,
  dbSchema: DBAttemptScanSchema,
  transformers: [
    createTimestampTransformer<typeof AttemptScanSchema, typeof DBAttemptScanSchema>('createdAt'),
    createTimestampTransformer<typeof AttemptScanSchema, typeof DBAttemptScanSchema>('updatedAt', {
      nullable: true,
    }),
    createTimestampTransformer<typeof AttemptScanSchema, typeof DBAttemptScanSchema>(
      'dismissedAt',
      { nullable: true }
    ),
  ],
};

export const encodeAttemptScanToDb = createEncodeToDbFn(AttemptScanCodecConfig);
export const decodeAttemptScanFromDb = createDecodeFromDbFn(AttemptScanCodecConfig);

export const ListedAttemptScanCodecConfig: TransformerConfig<
  typeof ListedAttemptScanSchema,
  typeof DBListedAttemptScanSchema
> = {
  name: 'ListedAttemptScan',
  clientSchema: ListedAttemptScanSchema,
  dbSchema: DBListedAttemptScanSchema,
  transformers: [
    createTimestampTransformer<typeof ListedAttemptScanSchema, typeof DBListedAttemptScanSchema>(
      'createdAt'
    ),
    createTimestampTransformer<typeof ListedAttemptScanSchema, typeof DBListedAttemptScanSchema>(
      'updatedAt',
      { nullable: true }
    ),
    createTimestampTransformer<typeof ListedAttemptScanSchema, typeof DBListedAttemptScanSchema>(
      'dismissedAt',
      { nullable: true }
    ),
  ],
};

export const decodeListedAttemptScanFromDb = createDecodeFromDbFn(ListedAttemptScanCodecConfig);

export const AttemptScanPageCodecConfig: TransformerConfig<
  typeof AttemptScanPageSchema,
  typeof DBAttemptScanPageSchema
> = {
  name: 'AttemptScanPage',
  clientSchema: AttemptScanPageSchema,
  dbSchema: DBAttemptScanPageSchema,
  transformers: [
    createTimestampTransformer<typeof AttemptScanPageSchema, typeof DBAttemptScanPageSchema>(
      'createdAt'
    ),
  ],
};

export const encodeAttemptScanPageToDb = createEncodeToDbFn(AttemptScanPageCodecConfig);
export const decodeAttemptScanPageFromDb = createDecodeFromDbFn(AttemptScanPageCodecConfig);
